import React, {Component} from 'react';
import PrintTwoPagesDoc from './PrintTwoPagesDoc';

class PrintTwoPagesPurchaseOrderDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = {}

  }

  componentDidMount(){

  }

  render() {
    return(
      <PrintTwoPagesDoc
        title={'ใบสั่งซื้อ'} 
        doc={'purchase_received_doc'}
        docNo={this.props.poNo}
        param={'po'}
      >
      </PrintTwoPagesDoc>
    )
  }
}  

export default PrintTwoPagesPurchaseOrderDoc;


// WEBPACK FOOTER //
// ./src/view/print/PrintTwoPagesPurchaseOrderDoc.js